import { FormInstance, Checkbox, Divider, Form } from "antd";
import type { CheckboxProps } from 'antd';
import { useEffect, useState } from 'react';

import requiredRule from "../../../../../utils/formRules/requiredRule";
import { useGetTrialModeNotificationChildQuery } from "../../../../../graphql/operations/trialMode/pushNotification/get-trial-mode-notification-child";


export default function FormItemChildAgeRange({
  form,
  hasError,
}: {
    form: FormInstance<any>;
    hasError: boolean;
}) {
  const CheckboxGroup = Checkbox.Group;

  const { data } = useGetTrialModeNotificationChildQuery();

  const rawChildAgeOptions = data?.wf_trialModeLeads_notificationChild?.nodes ?? [];

  const childAgeOptions = rawChildAgeOptions.map(item => ({
    label: item.notificationChildAgeName!,
    value: item.notificationChildAge!,
  }));

  const defaultValues = childAgeOptions.map((opt) => opt.value);

  const [checkedList, setCheckedList] = useState<string[]>([]);

  const checkAll = childAgeOptions.length === checkedList.length;
  const indeterminate = checkedList.length > 0 && checkedList.length < childAgeOptions.length;

  const onOptionChange = (list: string[]) => {
    setCheckedList(list);
    setFormValue(list);
  };

  const onCheckAllChange: CheckboxProps['onChange'] = (e) => {
    const optionValue = e.target.checked ? childAgeOptions.map(opt => opt.value) : [];
    setCheckedList(optionValue);
    setFormValue(optionValue);
  };

  const setFormValue = (optionValue: string[]) => {
    form.setFieldsValue({
      childAge: optionValue,
    });
  };

  useEffect(() => {
    const optionValue = childAgeOptions.map(opt => opt.value);
    setCheckedList(optionValue);
    setFormValue(optionValue);
  }, [data]);

  return (
    <Form.Item
      name="childAge"
      label="Child age range"
      rules={[{ required: true, message: "" }]}
      initialValue={defaultValues}
    >
      <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
        Check all
      </Checkbox>
      <p style={{ fontSize: '14px', lineHeight: '22px', marginTop: 5, color: hasError ? "#ff4d4f" : "rgba(0,0,0,0.45)", }}>
        Select one or more age ranges. Notification will be sent to recipients with children in the selected ranges.
      </p>
      <Divider style={{ marginBottom: 12, marginTop: 12 }} />
      <CheckboxGroup options={childAgeOptions} value={checkedList} onChange={onOptionChange} />
    </Form.Item >
  );
}
